module.exports = __webpack_public_path__ + "static/img/logo.a504515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/logo.png
// module id = Zd90
// module chunks = 67